import classNames from "classnames";
import styles from "./status-block.module.scss";
import { CSSProperties } from "react";
import InfoIcon from "@assets/icons/info.svg";

export enum StatusBlockType {
  Success = 0,
  Warning = 1,
  Error = 2,
  Orange = 3,
  Grey = 4,
}

type Props = {
  text: string | number;
  type: StatusBlockType;
  hint?: string;
  style?: CSSProperties;
};

export const StatusBlock = ({ text, type, style, hint }: Props) => {
  return (
    <div
      style={style}
      className={classNames(
        styles.statusBlock,
        type === StatusBlockType.Success && styles.statusSuccess,
        type === StatusBlockType.Warning && styles.statusWarning,
        type === StatusBlockType.Orange && styles.orange,
        type === StatusBlockType.Error && styles.statusError,
        type === StatusBlockType.Grey && styles.grey
      )}
      title={hint}
    >
      {text}
      {hint && <InfoIcon style={{ width: "16px", height: "16px" }} />}
    </div>
  );
};
